"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkActionDialog = void 0;
const react_1 = require("react");
const table_context_1 = require("../table-context");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const snackbar_context_1 = require("../../snackbar/snackbar-context");
const snackbar_types_1 = require("../../snackbar/snackbar-types");
const react_intl_1 = require("react-intl");
const evidence_context_1 = require("../../evidence/evidence-context");
const table_data_hook_1 = require("../hooks/table-data-hook");
function useBulkActionDialog({ url, paramsMapper, ref, apiCall, }) {
    const dialogRef = react_1.useRef(null);
    const formRef = react_1.useRef(null);
    const [submitting, setSubmitting] = react_1.useState(false);
    const { preFilters, filters, filtersState, searchQuery, totalCount, } = react_1.useContext(table_context_1.TableContext);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const filtersWithState = filters.map((filter, i) => ({
        ...filter,
        ...filtersState[i],
    }));
    const apiFilters = table_data_hook_1.convertToApiFilters(preFilters, filtersWithState, searchQuery);
    const applyToSelected = selected.length > 0;
    const count = applyToSelected ? selected.length : totalCount;
    const { detailRef, tableRef } = react_1.useContext(evidence_context_1.EvidenceContext);
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const intl = react_intl_1.useIntl();
    const openDialog = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    react_1.useImperativeHandle(ref, () => ({
        openDialog,
    }));
    const confirm = react_1.useCallback(() => {
        async function call() {
            var _a, _b, _c, _d;
            setSubmitting(true);
            const status = await apiCall(url, apiFilters, selected, paramsMapper((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFieldValues()));
            setSubmitting(false);
            if (status.error === undefined) {
                (_b = detailRef.current) === null || _b === void 0 ? void 0 : _b.refreshAll();
                (_c = tableRef.current) === null || _c === void 0 ? void 0 : _c.resetSelection();
                (_d = tableRef.current) === null || _d === void 0 ? void 0 : _d.refresh();
                showSnackbar(intl.formatMessage({
                    id: 'EAS_TABLE_BULK_ACTION_DIALOG_MSG_SUCCESS',
                    defaultMessage: 'Hromadná akce proběhla úspěšne.',
                }), snackbar_types_1.SnackbarVariant.SUCCESS);
            }
            else {
                showSnackbar(intl.formatMessage({
                    id: 'EAS_TABLE_BULK_ACTION_DIALOG_MSG_ERRORs',
                    defaultMessage: `Hromadná akce selhala. ${status.error}`,
                }), snackbar_types_1.SnackbarVariant.ERROR);
            }
        }
        call();
    }, [
        apiCall,
        apiFilters,
        detailRef,
        intl,
        paramsMapper,
        selected,
        showSnackbar,
        tableRef,
        url,
    ]);
    return {
        submitting,
        dialogRef,
        formRef,
        applyToSelected,
        count,
        confirm,
    };
}
exports.useBulkActionDialog = useBulkActionDialog;
//# sourceMappingURL=bulk-action-dialog-hook.js.map